import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { ClipboardList, Search, X } from "lucide-react";

export const EMPTY_FILTERS = { status: "all", city: "", date: "", richiedente: "all", fatturato: "all", type: "all" };

export const hasActiveFilters = (f) => f.status !== "all" || f.city.trim() || f.date || f.richiedente !== "all" || f.fatturato !== "all" || f.type !== "all";

export const applyFilters = (requests, f) => (requests || []).filter((r) => {
  if (f.type !== "all" && (r.request_type || "trasporto") !== f.type) return false;
  if (f.status !== "all" && r.status !== f.status) return false;
  if (f.richiedente !== "all" && (r.operative?.provenienza || "") !== f.richiedente) return false;
  if (f.fatturato === "si" && !r.fatturato) return false;
  if (f.fatturato === "no" && r.fatturato) return false;
  if (f.city.trim()) {
    const hay = `${r.partenza?.citta || ""} ${r.arrivo?.citta || ""} ${r.patient?.nominativo || ""} ${r.evento?.denominazione || ""} ${r.evento?.luogo || ""}`.toLowerCase();
    if (!hay.includes(f.city.trim().toLowerCase())) return false;
  }
  if (f.date && (r.operative?.data_ora_evento || "").slice(0, 10) !== f.date) return false;
  return true;
});

const Sel = ({ testid, value, onChange, placeholder, children }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid} className="h-9 w-full"><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>{children}</SelectContent>
  </Select>
);

export const DashboardFilters = ({ filters, setFilters, richiedentiOptions }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <div className="px-5 py-4 border-b border-slate-200 space-y-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2"><ClipboardList className="h-4 w-4 text-primary" /><h3 className="font-semibold text-slate-800">Elenco Richieste</h3></div>
        {hasActiveFilters(filters) && (
          <Button data-testid="clear-filters" variant="ghost" size="sm" className="gap-1 h-8" onClick={() => setFilters(EMPTY_FILTERS)}><X className="h-4 w-4" /> Reset filtri</Button>
        )}
      </div>
      <div data-testid="dashboard-filters-row" className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 items-center gap-3">
        <div className="relative">
          <Search className="h-4 w-4 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2" />
          <Input data-testid="filter-city" placeholder="Cerca città o paziente..." value={filters.city} onChange={(e) => set("city")(e.target.value)} className="pl-8 h-9 w-full" />
        </div>
        <Input data-testid="filter-date" type="date" value={filters.date} onChange={(e) => set("date")(e.target.value)} className="h-9 w-full" />
        <Sel testid="filter-richiedente" value={filters.richiedente} onChange={set("richiedente")} placeholder="Richiedente">
          <SelectItem value="all">Tutti i richiedenti</SelectItem>
          {richiedentiOptions.map((n) => <SelectItem key={n} value={n}>{n}</SelectItem>)}
        </Sel>
        <Sel testid="filter-type" value={filters.type} onChange={set("type")} placeholder="Tipo">
          <SelectItem value="all">Tutti i tipi</SelectItem><SelectItem value="trasporto">Trasporti</SelectItem><SelectItem value="evento">Eventi</SelectItem>
        </Sel>
        <Sel testid="filter-status" value={filters.status} onChange={set("status")}>
          <SelectItem value="all">Tutti gli stati</SelectItem><SelectItem value="pubblicata">Pubblicata</SelectItem><SelectItem value="assegnato">Assegnato</SelectItem>
          <SelectItem value="completata">Completata</SelectItem><SelectItem value="da_fatturare">Fatturare</SelectItem>
        </Sel>
        <Sel testid="filter-fatturato" value={filters.fatturato} onChange={set("fatturato")} placeholder="Fatturato">
          <SelectItem value="all">Tutti (fatturato)</SelectItem><SelectItem value="no">Fatturare</SelectItem><SelectItem value="si">Già fatturati</SelectItem>
        </Sel>
      </div>
    </div>
  );
};
